import * as React from "react";
import { Card, CardContent, Divider, Stack, Typography } from "@mui/material";
import { layout } from "./tokens";

export type RecordMetaRow = {
  label: React.ReactNode;
  value: React.ReactNode;
};

type Props = {
  title?: React.ReactNode;
  rows: RecordMetaRow[];
};

export function RecordMetaCard({ title = "Systemdaten", rows }: Props) {
  return (
    <Card
      elevation={layout.card.elevation}
      variant={layout.card.variant}
      sx={{
        borderRadius: layout.card.radius,
      }}
    >
      <CardContent
        sx={{
          p: layout.card.padding,
          "&:last-child": { pb: layout.card.padding },
        }}
      >
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <Stack divider={<Divider flexItem />} spacing={0}>
          {rows.map((row, index) => (
            <Stack
              key={index}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={2}
              sx={{ py: 1.5 }}
            >
              <Typography variant="body2" color="text.secondary">
                {row.label}
              </Typography>

              <Typography
                variant="body2"
                fontWeight={400}
                textAlign="right"
                sx={{ minWidth: 0 }}
              >
                {row.value}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
